import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;

  justify-content: flex-end;

  button {
    width: 250px;
    margin-left: 20px;
  }
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
`;
